/*
 * サブシステム名：
 * 機能名：受注・実績一覧
 */
import DdDateRangeBox from '@/components/DdDateRangeBox'
import VTour from '@/components/DdCoachMark.vue'
import CoachMark from './CoachMark/D2PRMT0010.js'

import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
import indexeddb from '@/ddv2.library/indexeddb'
import modals from '@/ddv2.library/modals'

import flowMixin from '@/mixins/flowMixins'
import validators from '@/rahmen/validators'

import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

const DdCheckbox = () => import('@/components/DdCheckbox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdSearchList = () => import('@/components/DdSearchList')
const DdTextBox = () => import('@/components/DdTextBox')

export default {
  name: 'PrmHaishaList',
  mixins: [flowMixin],
  components: {
    VTour,
    DdDateRangeBox,
    DdCheckbox,
    DdCodeTextBox,
    DdSearchList,
    DdTextBox
  },
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 25,
    page: 1,
    isCsvDownloader: false,
    isExcelDownloader: false,

    // 検索条件
    conditions: {
      unkoYoteiStartYmdString: null,
      unkoYoteiEndYmdString: null,
      haishaEigyoshoId: null,
      tokuisakiId: null,
      hacchusakiId: null,
      jomuinJininId: null,
      sharyoId: null,
      meisaiHeadFlg: false
    },
    conditionDetails: [
      { key: 'unkoYmdFromTo', name: '運行日', value: 'unkoYmdFromTo', type: 'value', delete: false, showValue: true, convertValue: false },
      { key: 'haishaEigyoshoId', name: '配車営業所', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msteigyosho' },
      { key: 'tokuisakiId', name: '荷主', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msttorihikisaki' },
      { key: 'hacchusakiId', name: '傭車先', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msttorihikisaki' },
      { key: 'jomuinJininId', name: '乗務員', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'mstjinin' },
      { key: 'sharyoId', name: '車両', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'mstsharyo' },
      { key: 'meisaiHeadFlg', name: '先頭の受注のみ表示', value: null, type: 'checkbox', delete: true, showValue: false, convertValue: false },
      { key: 'juchuEigyoshoId', name: '売上営業所', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msteigyosho' }
    ],

    // 検索結果
    rows: [],

    // 権限
    modeKengen: 0,

    // 操作ガイド用
    startCoachMark: false,
    steps: CoachMark.STEPS,

    // ヘッダー定義
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstJininHeaders: header.mstJininHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,
    mstSharyoHeaders: header.vwCMstSharyoHeaders
  }),
  watch: {
    /**
     * 検索条件簡易表示用
     * @param {} n
     */
    // 運行日
    'conditions.unkoYoteiStartYmdString': function (n) {
      var unkoYmdFromTo = ![undefined, null, ''].includes(this.conditions.unkoYoteiStartYmdString) ? this.conditions.unkoYoteiStartYmdString.slice(-5) : ''
      unkoYmdFromTo = unkoYmdFromTo + (![undefined, null, ''].includes(this.conditions.unkoYoteiEndYmdString) ? '～' + this.conditions.unkoYoteiEndYmdString.slice(-5) : '')
      this.conditions.unkoYmdFromTo = unkoYmdFromTo
    },
    'conditions.unkoYoteiEndYmdString': function (n) {
      var unkoYmdFromTo = ![undefined, null, ''].includes(this.conditions.unkoYoteiStartYmdString) ? this.conditions.unkoYoteiStartYmdString.slice(-5) : ''
      unkoYmdFromTo = unkoYmdFromTo + (![undefined, null, ''].includes(this.conditions.unkoYoteiEndYmdString) ? '～' + this.conditions.unkoYoteiEndYmdString.slice(-5) : '')
      this.conditions.unkoYmdFromTo = unkoYmdFromTo
    }
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      sharyoList: 'DDMasters/vwCMstSharyo',
      shubetsuList: 'DDMasters/mstShubetsu',
      currentKaishaCode: 'users/currentKaishaCode',
      userId: 'users/userId',
      usersEigyoshoCd: 'users/eigyoshoCd',
      userSettings: 'DDMasters/mstUserSettings',
      helpUseFlg: 'users/helpUseFlg',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    viewStyleType () {
      const type = [undefined, null].includes(this.userSettings) || [undefined, null].includes(this.userSettings.useNippoEditType) ? 1 : this.userSettings.useNippoEditType
      return type
    },
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        elem.juchuJissekiId = String(elem.keikakujissekikey) + String(elem.juchuNo)
        elem.unkoYmdDisp = elem.unkoYmd ? filter.dateFormatter(elem.unkoYmd) : ''
        elem.jissekiKakuninZumiFlgDisp = elem.jissekiKakuninZumiFlg ? '〇' : ''
        elem.haishaEigyoshoDisp = elem.haishaEigyoshoCd ? elem.haishaEigyoshoCd + ' : ' + elem.haishaEigyoshoNm : ''
        elem.haishaTantoshaDisp = elem.haishaTantoJininCd ? elem.haishaTantoJininCd + ' : ' + elem.haishaTantoJininNm : ''
        elem.hacchusakiDisp = elem.hacchusakiCd ? elem.hacchusakiCd + ' : ' + elem.hacchusakiNm : ''
        elem.sharyoDisp = elem.sharyoNo ? elem.sharyoNo + ' : ' + elem.torokuNo : ''
        elem.jomuinDisp = elem.jomuinJininCd ? elem.jomuinJininCd + ' : ' + elem.jomuinJininNmSei : ''
        elem.dojoshaDisp = elem.joshuJininCd ? elem.joshuJininCd + ' : ' + elem.joshuJininNmSei : ''
        elem.juchuEigyoshoDisp = elem.juchuEigyoshoCd ? elem.juchuEigyoshoCd + ' : ' + elem.juchuEigyoshoNm : ''
        elem.tokuisakiDisp = elem.tokuisakiCd ? elem.tokuisakiCd + ' : ' + elem.tokuisakiNm : ''
        elem.unchinKakuteiFlgDisp = elem.unchinKakuteiFlg ? '〇' : ''
        elem.seikyuTomeFlgDisp = elem.seikyuTomeFlg ? '〇' : ''
        // elem.hatsuchiDisp = elem.hatsuchiCd ? elem.hatsuchiCd + ' : ' + elem.hatsuchiNm : elem.hatsuchiBiko
        elem.hatsuchiDisp = elem.hatsuchiCd ? elem.hatsuchiNm : elem.hatsuchiBiko
        elem.hatsuchiYmdDisp = elem.hatsuchiYmd ? filter.dateFormatter(elem.hatsuchiYmd) : ''
        elem.hatsuchiHmsDisp = elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : ''
        elem.keiyuchi1Disp = elem.keiyuchi1Cd ? elem.keiyuchi1Cd + ' : ' + elem.keiyuchi1Nm : elem.keiyuchiId1Biko
        // elem.chakuchiDisp = elem.chakuchiCd ? elem.chakuchiCd + ' : ' + elem.chakuchiNm : elem.chakuchiBiko
        elem.chakuchiDisp = elem.chakuchiCd ? elem.chakuchiNm : elem.chakuchiBiko
        elem.chakuchiYmdDisp = elem.chakuchiYmd ? filter.dateFormatter(elem.chakuchiYmd) : ''
        elem.chakuchiHmsDisp = elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : ''
        // elem.hinmeiDisp = elem.hinmeiCd ? elem.hinmeiCd + ' : ' + elem.hinmeiNm : elem.hinmeiBiko
        elem.hinmeiDisp = elem.hinmeiCd ? elem.hinmeiNm : elem.hinmeiBiko
        elem.juchuSuryoDisp = elem.juchuSuryo ? filter.numericFormatter(elem.juchuSuryo) : ''
        elem.tankaDisp = elem.tanka ? filter.numericFormatter(elem.tanka) : ''
        elem.juchuJuryoDisp = elem.juchuJuryo ? filter.numericFormatter(elem.juchuJuryo) : ''
        elem.warimashiKyoriTankaDisp = elem.warimashiKyoriTanka ? filter.numericFormatter(elem.warimashiKyoriTanka) : ''
        elem.warimashiTaishoKyoriDisp = elem.warimashiTaishoKyori ? filter.numericFormatter(elem.warimashiTaishoKyori) : ''
        elem.seikyuYoteiYmdDisp = elem.seikyuYoteiYmd ? filter.dateFormatter(elem.seikyuYoteiYmd) : ''
        // elem.kihonUnchinDisp = elem.kihonUnchin ? filter.numericFormatter(elem.kihonUnchin) : ''
        // elem.unchinHokaKingakuDisp = elem.unchinHokaKingaku ? filter.numericFormatter(elem.unchinHokaKingaku) : ''
        // elem.hiwayPriceDisp = elem.hiwayPrice ? filter.numericFormatter(elem.hiwayPrice) : ''
        // elem.unchinHokaHikazeiDisp = elem.unchinHokaHikazei ? filter.numericFormatter(elem.unchinHokaHikazei) : ''
        // elem.jikanWarimashiKingakuDisp = elem.jikanWarimashiKingaku ? filter.numericFormatter(elem.jikanWarimashiKingaku) : ''
        // elem.kyoriWarimashiKingakuDisp = elem.kyoriWarimashiKingaku ? filter.numericFormatter(elem.kyoriWarimashiKingaku) : ''
        // elem.sonotaWarimashiKingakuDisp = elem.warimashiSonotaKingsku ? filter.numericFormatter(elem.warimashiSonotaKingsku) : ''
        elem.shiharaiYoteiYmdDisp = elem.shiharaiYoteiYmd ? filter.dateFormatter(elem.shiharaiYoteiYmd) : ''
        // elem.shiharaiKihonUnchinDisp = elem.yoshaKihonUnchin ? filter.numericFormatter(elem.yoshaKihonUnchin) : ''
        // elem.shiharaiHiwayPriceDisp = elem.yoshaHiwayPrice ? filter.numericFormatter(elem.yoshaHiwayPrice) : ''
        // elem.shiharaiKingakuKazeiDisp = elem.yoshaUnchinHokaKingaku ? filter.numericFormatter(elem.yoshaUnchinHokaKingaku) : ''
        // elem.shiharaiKingakuHiKazeiDisp = elem.yoshaUnchinHokaHikazei ? filter.numericFormatter(elem.yoshaUnchinHokaHikazei) : ''
        elem.seikyuKingakuGokeiDisp = elem.seikyuKingakuGokei ? filter.numericFormatter(elem.seikyuKingakuGokei) : ''
        elem.shiharaiKingakuGokeiDisp = elem.shiharaiKingakuGokei ? filter.numericFormatter(elem.shiharaiKingakuGokei) : ''
        elem.chumonshoReceiveZumiFlgDisp = elem.chumonshoReceiveZumiFlg ? '受領済' : ''
        elem.chumonkakuninshoSendZumiFlgDisp = elem.chumonkakuninshoSendZumiFlg ? '送付済' : ''
        elem.hacchushoSendZumiFlgDisp = elem.hacchushoSendZumiFlg ? '送付済' : ''
        elem.motoukeHokokuZumiFlgDisp = elem.motoukeHokokuZumiFlg ? '報告済' : ''
        elem.hatsuchiOdoMater = elem.hatsuchiOdoMater ? filter.numericFormatter(elem.hatsuchiOdoMater) : ''
        elem.chakuchiOdoMater = elem.chakuchiOdoMater ? filter.numericFormatter(elem.chakuchiOdoMater) : ''
        return elem
      }).sort((a, b) => {
        if (a.unkoYmd > b.unkoYmd) { return -1 }
        if (a.unkoYmd === b.unkoYmd) {
          if (a.trUnkoJissekiId > b.trUnkoJissekiId) { return -1 }
          if (a.trUnkoJissekiId === b.trUnkoJissekiId) {
            if (a.meisaiOrder > b.meisaiOrder) { return 1 }
            if (a.meisaiOrder === b.meisaiOrder) { return 0 }
            return -1
          }
          return 0
        }
        return 1
      /*
      }).sort((a, b) => {
        if (a.trUnkoJissekiId > b.trUnkoJissekiId) { return -1 }
        if (a.trUnkoJissekiId === b.trUnkoJissekiId) { return 0 }
        return 1
      }).sort((a, b) => {
        if (a.meisaiOrder > b.meisaiOrder) { return 1 }
        if (a.meisaiOrder === b.meisaiOrder) { return 0 }
        return -1
      */
      })
    },
    // 営業所フィルター
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      })
    },
    // 人員フィルター
    filteredJininList () {
      const target = filter.dateFormatter(new Date())
      const self = this
      return this.eigyoshoJininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03' && (self.eigyoshoLockFlg || elem.eigyoshoCd === self.usersEigyoshoCd)
      })
    },
    // 配車担当者フィルター
    filteredHaishaTantoshaList () {
      const target = filter.dateFormatter(new Date())
      const self = this
      return this.eigyoshoJininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03' && (self.eigyoshoLockFlg || elem.eigyoshoCd === self.usersEigyoshoCd)
      })
    },
    // 取引先フィルター
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    // 得意先フィルター
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })
    },
    // 傭車先フィルター
    filteredMstHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === true
      })
    },
    // 車両マスタフィルター
    filteredMstSharyoList () {
      const target = filter.dateFormatter(new Date())
      const self = this
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.hacchusakiFlg === false && (self.eigyoshoLockFlg || elem.eigyoshoCd === self.usersEigyoshoCd)
      })
    },
    // 車両グループフィルター
    filteredSharyoGroup1ShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI012')
    },
    filteredSharyoGroup2ShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI013')
    },
    // CSVボタン活性条件
    isCsvButtonDisabled () {
      return this.rows.length === 0 || this.isCsvDownloader
    },
    // Excelボタン活性条件
    isExcelButtonDisabled () {
      return this.rows.length === 0 || this.isExcelDownloader
    },
    deleteButtonDisp () {
      // 現時点では使用しない
      // if (this.modeKengen === 2) {
      //   return true
      // } else {
      //   return false
      // }
      return false
    },
    isDeleteButtonDisabled () {
      if (this.modeKengen !== 2) {
        return true
      }
      if (this.selected.length > 0) {
        return false
      }
      return true
    },
    isEditButtonDisabled () {
      if (this.modeKengen === 0) {
        return true
      }
      if (this.selected.length === 1) {
        return false
      }
      return true
    },

    // 追加ボタン活性条件
    createButtonDisp () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    getNextTransition: function () {
      if ([undefined, null].includes(this.userSettings)) {
        return 1
      }
      const nextTransition = ![undefined, null].includes(this.userSettings.useNippoEditTransition) ? this.userSettings.useNippoEditTransition : 1
      return nextTransition
    },
    initialize () {
      console.log('initialize')
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'vwcmsteigyoshojininlist', 'msttorihikisaki', 'vwcmstsharyo', 'mstshubetsu'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('PrmHaishaList.defineHeaderPromise')
            this.headers = [
              { text: '編集', value: 'actions', sortable: false, width: '20px' },
              { text: '運行日', value: 'unkoYmdDisp' },
              // { text: '運賃確定済み', value: 'unchinKakuteiFlgDisp', align: 'center' },
              // { text: '配車確定済', value: 'keikakuKakuteiFlgDisp', align: 'center' },
              // { text: '実績登録済', value: 'jissekiTorokuKbnDisp', align: 'center' },
              // { text: '運行実績No', value: 'unkoJissekiNo' },
              // { text: '実績確認済', value: 'jissekiKakuninZumiFlgDisp', align: 'center', sortable: false },
              { text: '配車営業所', value: 'haishaEigyoshoNm' },
              // { text: '登録担当者', value: 'haishaTantoshaDisp' },
              // { text: '配車先区分', value: 'dispHaishaKbnLite' },
              { text: '乗務員', value: 'jomuinJininNmSei' },
              // { text: '同乗者', value: 'dojoshaDisp' },
              { text: '傭車先', value: 'hacchusakiNm' },
              // { text: '車両番号/ナンバープレート', value: 'sharyoDisp' },
              { text: '自動車表示名', value: 'jidoshaHyojiNm' },
              { text: '車種', value: 'sharyoShashuSbt' },
              // { text: '配送明細No', value: 'meisaiOrder' },
              // { text: '受注No', value: 'juchuNo' },
              { text: '売上営業所', value: 'juchuEigyoshoNm' },
              { text: '荷主', value: 'tokuisakiNm' },
              // { text: '注文番号', value: 'chumonNo' },
              // { text: 'コース名', value: 'courseNm' },
              // { text: '往復種別', value: 'ohfukuSbtNm' },
              { text: '発地', value: 'hatsuchiDisp' },
              // { text: '発地年月日', value: 'hatsuchiYmdDisp' },
              // { text: '発地時刻', value: 'hatsuchiHmsDisp' },
              // { text: '経由地', value: 'keiyuchi1Disp' },
              // { text: '経由地２', value: 'keiyuchi2Disp' },
              // { text: '経由地３', value: 'keiyuchi3Disp' },
              // { text: '経由地４', value: 'keiyuchi4Disp' },
              // { text: '経由地５', value: 'keiyuchi5Disp' },
              { text: '着地', value: 'chakuchiDisp' }
              // { text: '着地年月日', value: 'chakuchiYmdDisp' },
              // { text: '着地時刻', value: 'chakuchiHmsDisp' },
            ]
            if (this.viewStyleType !== 1) {
              this.headers.push({ text: '商品', value: 'hinmeiDisp' })
              this.headers.push({ text: '数量', value: 'juchuSuryoDisp', align: 'end' })
              this.headers.push({ text: '単位', value: 'unitKbnNm' })
              this.headers.push({ text: '重量(t)', value: 'juchuJuryoDisp', align: 'end' })
              this.headers.push({ text: '単価', value: 'tankaDisp' })
            }
            this.headers.push({ text: '請求計上日', value: 'seikyuYoteiYmdDisp' })
            if (this.viewStyleType !== 1) {
              this.headers.push({ text: '運賃計算区分', value: 'unchinKeisanKbnNm' })
            }
            this.headers.push({ text: '請求車種', value: 'seikyuShashuSbtNm' })
            this.headers.push({ text: '請求金額合計', value: 'seikyuKingakuGokeiDisp', align: 'end' })
            // { text: '運賃', value: 'kihonUnchinDisp', align: 'end' },
            // { text: '保管料', value: 'hokanKingakuDisp', align: 'end' },
            // { text: '荷役量', value: 'niekiKingakuDisp', align: 'end' },
            // { text: '運賃(高速)', value: 'hiwayPriceDisp', align: 'end' },
            // { text: 'その他課税', value: 'unchinHokaKingakuDisp', align: 'end' },
            // { text: 'その他非課税', value: 'unchinHokaHikazeiDisp', align: 'end' },
            // { text: '立替金(非)', value: 'tatekaekinHikazeiDisp', align: 'end' },
            // { text: '時間割増金額', value: 'jikanWarimashiKingakuDisp', align: 'end' },
            // { text: '距離割増金額', value: 'kyoriWarimashiKingakuDisp', align: 'end' },
            // { text: 'その他割増金額', value: 'sonotaWarimashiKingakuDisp', align: 'end' },
            this.headers.push({ text: '支払計上日', value: 'shiharaiYoteiYmdDisp' })
            this.headers.push({ text: '支払金額合計', value: 'shiharaiKingakuGokeiDisp', align: 'end' })
            // { text: '支払運賃', value: 'shiharaiKihonUnchinDisp', align: 'end' },
            // { text: '支払運賃（高速）', value: 'shiharaiHiwayPriceDisp', align: 'end' },
            // { text: '支払その他課税', value: 'shiharaiKingakuKazeiDisp', align: 'end' },
            // { text: '支払その他非課税', value: 'shiharaiKingakuHiKazeiDisp', align: 'end' }
            // { text: '運行手当', value: 'sagyoinTeateKingaku1Disp', align: 'end' },
            // { text: '高速ETC', value: 'sharyoKeihiHiwayEtcDisp', align: 'end' },
            // { text: '高速現金', value: 'sharyoKeihiHiwayGenkinDisp', align: 'end' },
            // { text: 'フェリー', value: 'sharyoKeihiFerryDisp', align: 'end' },
            // { text: '社内傭車額', value: 'sharyoKeihiEtc1Disp', align: 'end' }
            this.headers.push({ text: '荷主書面(受)', value: 'chumonshoReceiveZumiFlgDisp', align: 'center' })
            this.headers.push({ text: '荷主書面(交付)', value: 'chumonkakuninshoSendZumiFlgDisp', align: 'center' })
            this.headers.push({ text: '傭車書面(交付)', value: 'hacchushoSendZumiFlgDisp', align: 'center' })
            this.headers.push({ text: '実運送報告', value: 'motoukeHokokuZumiFlgDisp', align: 'center' })
            this.headers.push({ text: '注文番号', value: 'chumonNo' })
            this.headers.push({ text: '運行実績No', value: 'unkoJissekiNo' })
            this.headers.push({ text: '受注No', value: 'juchuNo' })
            this.headers.push({ text: '#', value: 'meisaiOrder' })

            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('PrmHaishaList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('PrmHaishaList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('PrmHaishaList.researchPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('PrmHaishaList.restoreViewPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
              self.searchText = c.cache.value.searchText || ''
              self.rows = c.cache.value.rows || []
            }
            resolve()
          })
        },
        settingViewScroll: () => {
          return false
        },
        settingButtonStatePromise: (kengen) => {
          console.log('PrmHaishaList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.rows = []
      this.selected = []
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2prmd0010/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            meisaiHeadFlg: self.conditions.meisaiHeadFlg
          }
        }
      }
      this.search(opt)
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      const d = new Date()
      const initConditions = {
        unkoYoteiStartYmdString: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
        unkoYoteiEndYmdString: date.getLastDate(d.getFullYear(), d.getMonth() + 1),
        haishaEigyoshoId: indexeddb.getRecordByCd(this.currentKaishaCode, this.filteredEigyoshoList, 'eigyoshoCd', this.usersEigyoshoCd, date.getCurrentDate()).id,
        jomuinJininId: null,
        tokuisakiId: null,
        ninushiId: null,
        juchuEigyoshoId: null,
        haishaTantoJininId: null,
        sharyoId: null,
        hacchusakiId: null,
        sharyoGroup1: null,
        sharyoGroup2: null,
        jissekiTorokuKbn: '03',
        jissekiKakuninKbn: '03',
        haishaStatusKbn: '03',
        haishasakiKbn: '01',
        meisaiHeadFlg: false
      }
      this.conditions = {
        ...initConditions,
        // 表示用
        unkoYmdFromTo: initConditions.unkoYoteiStartYmdString.slice(-5) + '～' + initConditions.unkoYoteiEndYmdString.slice(-5),
        haishaEigyoshoNm: indexeddb.getRecord(this.filteredEigyoshoList, initConditions.haishaEigyoshoId).eigyoshoNm,
        tokuisakiNm: '',
        yoshasakiNm: '',
        jomuinJininNm: '',
        jidoshaHyojiNm: '',
        juchuEigyoshoNm: ''
      }
      this.searchText = ''
      this.rows = []
      this.page = 1
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.initBindVariables()
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onRemoveConditionClick: function (itemNm, type) {
      if (type === 'checkbox') {
        this.conditions[itemNm] = false
      } else {
        this.conditions[itemNm] = null
      }
      /*
      this.$nextTick(() => {
        this.onSearchButtonClick()
      })
      */
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(this.getNextTransition(), { id: [f.item.trUnkoJissekiId, f.item.keikakujissekikey, f.item.trJuchuKihonId] })
    },

    onDeleteButtonClick: function (e) {
      var isDelete = true
      // 削除可能チェック
      // 必要があれば

      // 削除処理実行
      if (isDelete) {
        const p = modals.showConfirm
        p('COMQ0003').then((ok) => {
          if (ok === false || ok === undefined) { return }

          this.Effects.loadStart()

          for (const r of this.selected) {
            this.deleteExec(r.id).then(() => {
              // 再検索
              this.onSearchButtonClick()

              this.Effects.loadComplete()
              modals.showSuccess('対象を削除しました。')
            })
          }
        })
      } else {
        modals.showError('計画済・作業完了・実績確認済み・請求済みの受注は削除できません。<br>対象を見直してください。')
      }
    },
    deleteExec: function (id) {
      return new Promise((resolve) => {
        this.HttpClient.delete(`/api/v1/TrJuchuKihon/DeleteWithChildren?id=${id}&tm=${date.getCurrentDateTime()}`).then((data) => {
          resolve(data)
        })
      })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(this.getNextTransition(), { id: [item.trUnkoJissekiId, item.keikakujissekikey, item.trJuchuKihonId] })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(this.getNextTransition(), { id: [0, '0'] })
    },
    // 検索前チェック
    searchValidate: function () {
      /*
      if (!this.conditions.eigyoshoCd && !this.conditions.jomuinCd && !this.conditions.tokuisakiCd && !this.conditions.unkoYoteiStartYmdString && !this.conditions.unkoYoteiEndYmdString && !this.conditions.haishaTantoshaCd && !this.conditions.sharyoId && !this.conditions.hacchusakiCd && !this.conditions.unkoJissekiNo && !this.conditions.sharyoGroupSbt1 && !this.conditions.sharyoGroupSbt2 && this.conditions.haishaStatusKbn === '01' && this.conditions.haishasakiKbn === '01' && this.conditions.jissekiTorokuKbn === '01' && !this.conditions.meisaiHeadFlg) {
        this.setInvalidSummaryMessage('COME0026')
        return false
      }
      */
      // 運行予定年月日不整合チェック
      if (this.conditions.unkoYoteiStartYmdString && this.conditions.unkoYoteiEndYmdString) {
        const msg1 = validators.compareDate(this.conditions.unkoYoteiStartYmdString, this.conditions.unkoYoteiEndYmdString)
        if (msg1 !== undefined) {
          this.$refs.unkoYoteiStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.$refs.unkoYoteiEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.setInvalidSummaryMessage('COME0014')
          return false
        }
      }
      return true
    },
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      // this.$set(this, 'itemsPerPage', e)
      this.itemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      this.page = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    onDummyFunction: function () {
      return null
    }
  }
}
